var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnDelProdToCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_547_6821)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2.5,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#444444",
    fillOpacity: 0.05,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M8 8.5L20 20.5M18 10.5L17.7333 14.5M17.4999 18.0018L17.4661 18.5086C17.4193 19.21 17.3959 19.5607 17.2445 19.8267C17.1111 20.0608 16.9099 20.249 16.6674 20.3665C16.392 20.5 16.0405 20.5 15.3375 20.5H12.6625C11.9595 20.5 11.608 20.5 11.3326 20.3665C11.0901 20.249 10.8889 20.0608 10.7555 19.8267C10.604 19.5607 10.5807 19.21 10.5339 18.5086L10 10.5H8.66667M16.6667 10.5L16.3039 9.41169C16.1225 8.86724 15.6129 8.5 15.039 8.5H12.9611C12.6283 8.5 12.3172 8.62346 12.0791 8.83333M13.7422 10.5H19.3333M15.3333 15.8333V17.8333M12.6667 13.1667V17.8333",
    stroke: "#D41217",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_547_6821",
    x: 0,
    y: 0.5,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_547_6821"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_547_6821",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnDelProdToCart);
export default __webpack_public_path__ + "static/media/btn-delProdToCart.c9ba7de2f38eb075c268cc527e532291.svg";
export { ForwardRef as ReactComponent };